export default function useProductBuilder() {
    const parseConditions = (string) => String(string || '')
        .split(',')
        .map(value => value.trim())
        .filter(Boolean)

    const optionIsInvalid = (sku, option) => {
        const requiredValues = parseConditions(option.attributes.match)
        const missingRequiredValues = requiredValues.length ? !requiredValues.some((str) => sku.includes(str)) : false

        const rejectedValues = parseConditions(option.attributes.reject)
        const hasRejectedValues = rejectedValues.length ? rejectedValues.some((str) => sku.includes(str)) : false

        return missingRequiredValues || hasRejectedValues
    }

    const getSelectedOption = (config) => {
        return config.options.find((option) => option.attributes.value === config.value)
    }

    const getFirstEnabledOption = (sku, config) => {
        return config.options.find(option => !optionIsInvalid(sku, option))
    }

    const generateSku = (configuration) => {
        return configuration.value.reduce((str, config) => str + (config.value ?? ''), '').trim()
    }

    return {
        generateSku,
        getSelectedOption,
        getFirstEnabledOption,
        optionIsInvalid,
    };
}
